import { createGlobalStyle } from "styled-components";

import {
  CAPTIONED_LOADER_SPIN_CCW,
  CAPTIONED_LOADER_SPIN_CW,
} from "./captioned-loader.constants";

export const CaptionedLoaderAnimationStyles = createGlobalStyle`
  @keyframes ${CAPTIONED_LOADER_SPIN_CW} {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes ${CAPTIONED_LOADER_SPIN_CCW} {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }
`;
